// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Wg6e","dragIcon":"Choice_dragIcon__3GC_J","left":"Choice_left__11fPd","input":"Choice_input__2X8st"};